import { MDBBtn, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalFooter, MDBModalHeader, MDBModalTitle, MDBSpinner } from "mdb-react-ui-kit";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

/** flag value
 * 1. Add
 * 2. Save
 * 3. Delete
 * 4. Remove
 * 5. Save Changes
 * 6. Reset Password
 * 7. Send Welcome Email 
 * 8. Send
 * 9. Done
 * 10. Ok
 * 11. Move
 * 12. Import
 * 13. Export
 * 14. unassign
 * 15. Trust
 */

/**
 * hideClose = true , default false
 */
export default function PopupLoaderNew(props) {
  const [selectedRegion, setSelectedRegion] = useState("IN");
  const { t, i18n } = useTranslation();
  return (
    <>
      <MDBModal staticBackdrop open={true} closeOnEsc={false} setOpen={props.onShow} className={props.className == "modal-lg" ? props.className : "modal-sm" ? props.className : "modal-xl"}>
        {props.isloading && (
          <>
            <div className="loadingclass">
              <MDBBtn disabled>
                <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                Loading...
              </MDBBtn>
            </div>
          </>
        )}
        <MDBModalDialog size={props.size}>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>{props.title}</MDBModalTitle>
              <MDBBtn
                className="btn-close"
                color="none"
                onClick={(e) => props.onClose(e)}
                tabIndex={-1}
              ></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              {props.content}
            </MDBModalBody>
            <MDBModalFooter>
              <MDBBtn onClick={(e) => props.onClose(e)} hidden={props.hideClose ? props.hideClose : false} color="secondary" >
                {t("close")}
              </MDBBtn>
              <MDBBtn onClick={(e) => {
                e.preventDefault();
                props.onSave()
              }} color="primary" disabled={props.disableSave ? props.disableSave : false}>
                {props.flag === 1 ? t("add") : props.flag === 2 ? t("save") : props.flag === 3 ? t("delete") : props.flag === 4 ? t("remove") : props.flag === 5 ? t("saveChanges") : props.flag === 6 ? t("ResetPassword") : props.flag === 7 ? t("sendWelcomeEmail") : props.flag === 8 ? t("Send") : props.flag === 9 ? t("Done") : props.flag === 10 ? t("Ok") : props.flag === 11 ? t("Move") : props.flag === 12 ? t("Import") : props.flag === 13 ? t("Export") : props.flag === 14 ? t("unassign") : props.flag === 15 ? t("Trust") : t("Assign")}
              </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal >
    </>
  );
}
